import { IAppState } from '../../../AppModulesWrapper';
import { TOSType } from '../../types/layout';

export const selectLayoutOSType = (state: IAppState): TOSType => {
  return state.servicePickerWidget.layout.adaptiveSettings.deviceOperatingSystem;
};
